module.exports = __webpack_public_path__ + "img/1inch.da009cde.svg";